module.exports = __webpack_public_path__ + "static/logo-indah-kiat-e31a24fc5b63950a54b60a96bf61ea74.png";